module.exports = __webpack_public_path__ + "static/media/white-hearts.74e39f99.svg";